const siderBar = {
  profile: "Profiel",
  history: "Geschiedenis",
  setting: "Instellen",
  promotion: "Promotie",
};

export default siderBar;